export function* filter<T>(collection: Iterable<T>, predicate: (item: T) => boolean) {
  for (const item of collection) {
    if (predicate(item)) yield item;
  }
}
